// Copyright (c) 2025 WiseTime. All rights reserved.

import { combineEpics } from "redux-observable"
import { Action } from "redux"
import { RootState } from "../../../app/store"
import generateTimesheetFieldConfigs from "./generateTimesheetFieldConfigs"
import batchGetTimesheetFieldConfigs from "./batchGetTimesheetFieldConfigs"

export default combineEpics<Action, Action, RootState, unknown>(
  generateTimesheetFieldConfigs,
  batchGetTimesheetFieldConfigs,
)
